module.exports = __webpack_public_path__ + "img/img_leraning.5a547e15.png";